<div class="card">
  <app-header titulo="Responsável x Depósito" descricao="Cadastro de responsável por depósito"></app-header>

  <div class="field">
    <label for="codigoFuncionario">Cód. Funcionário:</label>
    <input id="codigoFuncionario" pInputText type="text" [(ngModel)]="registro.codigoFuncionario" class="w-full" required autofocus>
    <small class="p-error" *ngIf="enviado && !registro.codigoFuncionario">Código do funcionário é obrigatório.</small>
  </div>

  <div class="field">
    <label for="codigoDepositoOrigem">Depósito Origem:</label>
    <input id="codigoDepositoOrigem" pInputText type="text" [(ngModel)]="registro.codigoDepositoOrigem" class="w-full" required>
    <small class="p-error" *ngIf="enviado && !registro.codigoDepositoOrigem">Depósito de origem é obrigatório.</small>
  </div>

  <div class="field">
    <label for="codigoDepositoDestino">Depósito Destino:</label>
    <input id="codigoDepositoDestino" pInputText type="text" [(ngModel)]="registro.codigoDepositoDestino" class="w-full" required>
    <small class="p-error" *ngIf="enviado && !registro.codigoDepositoDestino">Depósito de destino é obrigatório.</small>
  </div>

  <div class="field col-2 pt-4">
    <button
      pButton
      icon="pi pi-save"
      class="p-button-success"
      [label]="registro.id ? 'Atualizar' : 'Salvar'"
      (click)="salvar()"
    ></button>
    <button
      pButton
      icon="pi pi-times"
      class="p-button-secondary ml-2"
      label="Cancelar"
      routerLink="/integracoes/movimentacoes/transferencia-insumos/deposito-responsavel"
    ></button>
  </div>
</div>
